import { armorAPI } from '~/services/api';

export interface FetchItemResult {
  items: {
    name: string;
  }[];
  total: number;
}

export function fetchItem(query: string, page: number) {
  const limit = 10;
  return armorAPI.request<FetchItemResult>({
    url: '/order_items',
    method: 'GET',
    params: {
      offset: limit * page,
      q: query,
      limit,
    },
  });
}
